import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useNavigate, useParams } from 'react-router-dom';

// core components
import Navbar from "../layouts/Navbar.js";
import Footer from "../layouts/Footer.js";

import '../../assets/css/Board.css'

// reactstrap components
import {
  Label,
  Input,
  Button
} from "reactstrap";

export default function UserUpdate() {

  const navigate = useNavigate();
  const { param } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState({});
;
  const [formData, setFormData] = useState({});

  const [userId, setUserId] = useState('');

  useEffect(() => {
    //console.log(param);

    if(param !== undefined){
      // 서버에서 게시글 데이터 가져오는 로직
      async function selectUserById() {

        //console.log("param id : " + param);

        //로딩중 표기
        setIsLoading(true);

        // 프로필 정보 불러오기
        let profileRequest;

        try {

          profileRequest = await axios.get(
            `/profile/getUserInfoById?userId=${param}`,
            { baseURL : process.env.REACT_APP_SERVER_URL,
            },{
              withCredentials: true
            })
            .then((response) => {
    
              profileRequest = response.data;
    
              if (profileRequest.success) {
                const userInfoData = profileRequest.userInfo;
    
                // DB에서 불러온 사용자 정보 세팅
                setFormData({
                  id: userInfoData.id,
                  email: userInfoData.email,
                  name: userInfoData.name,
                  cellphone: userInfoData.cellphone,
                  role: userInfoData.role,
                });
    
                setIsLoading(false);
                setUserId(userInfoData.email);
    
              } else {
                const errorMessage  = profileRequest.messages;
                // alert("errors : " + JSON.stringify(errorMessage.errors));
                if (errorMessage && errorMessage.databaseError) {
                  setErrorMessage({ errors : errorMessage.databaseError });
                }
              }
            })
            .catch((error) => {
              console.error('로그인 상태 확인 실패:', error);
            });

        } catch (error) {
          console.error('사용자 정보 조회 오류:', error);
        }
      }
      
      selectUserById();
    } else {
      setIsLoading(false);
    }

  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;

    // 파일 입력인 경우 파일 객체 설정
    if (type === 'file') {
      setFormData({
        ...formData,
        [name]: files[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

const updateUser = async (e) => {
    e.preventDefault();

    const fields = ["email", "name", "cellphone", "role"];
    const formElements = e.target.elements;

    const formValues = fields
    .map((field) => ({
      [field]: formElements.namedItem(field).value
    }))
    .reduce((current, next) => ({ ...current, ...next }));

    try {
      await axios.post(`/profile/updateUserByAdmin`,
      {
        ...formValues
      },
      { baseURL : process.env.REACT_APP_SERVER_URL
      },{
        withCredentials: true
      })
      .then((response) => {
        console.log("회원정보 업데이트 성공");

        const { data: registerRequestData } = response;
        const messages = registerRequestData.messages;
        // 성공 메세지 표출
        if (messages && messages.success) {
          alert(messages.success);
          // 성공 후 페이지 이동
          return navigate("/UserList");
        }
      })

    } catch ({ error }) {
      alert("회원정보 업데이트에 실패하였습니다. 잠시 후에 다시 시도해주세요.")
    }
  };

  const passwordInitialize = async() => {

    //console.log("param id : " + param);

    try {
      await axios.get(`/profile/updatePasswordInit?userId=${param}`,
      { baseURL : process.env.REACT_APP_SERVER_URL
      },{
        withCredentials: true
      })
      .then((response) => {
        //console.log("비밀번호 초기화 성공");

        const { data: registerRequestData } = response;
        const messages = registerRequestData.messages;
        // 성공 메세지 표출
        if (messages && messages.success) {
          alert(messages.success);
        }
      })

    } catch ({ error }) {
      alert("회원정보 업데이트에 실패하였습니다. 잠시 후에 다시 시도해주세요.")
    }
  };

  const deleteUser = async (e) => {
    e.preventDefault();

    if(window.confirm("회원 탈퇴 시 가입 관련 정보가 모두 즉시 삭제되며, 복구할 수 없습니다\n계속 진행하시겠습니까?")){

      let deleteRequest;

      try {
        deleteRequest = await axios.get(
          `/profile/deleteUserByAdmin?userId=${userId}`,
          { baseURL : process.env.REACT_APP_SERVER_URL },
          {
            withCredentials: true
          });
      } catch ({ response }) {
        deleteRequest = response;
      }
      const { data: deleteRequestData } = deleteRequest;

      const messages = deleteRequestData.messages;

      if ( deleteRequestData.success ) {

        // 성공 메세지 표출
        if (messages && messages.success) {
          alert(messages.success);
        }
        return navigate("/UserList");

      } else {
        // 실패 메세지 표출
        if (messages && messages.errors) {
          const errors = messages.errors;

          alert(errors.databaseError);
        }
      }
    } else {
      return
    }
  };
  
  return (
    <>
    <Navbar/>
      <div className="wrapper">
        <div className="page-header">
          <div className="page-header-image" />

            <div id="UserList" className="register-page">
            <div className="Section">
                <div className="cardWithTitle">
                <div className="SectionHeaderFull">
                    <div className="SectionHeaderTxtbox">
                    <div className="SectionHeaderCategory CategoryDark">User Management</div>
                    <div className="SectionHeaderTitle">회원 관리</div>
                    </div>
                </div>

                <div className="SectionContents" style={{marginTop:'30px'}}>
                    {isLoading &&
                          // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                        <div className="loader">
                          <div className="loader-container">
                            <p className='loader-title'>Loading...</p>
                          </div>
                        </div>
                    }
                    <div className="form-control">
                    <form onSubmit={updateUser}>
                        <div className="form-box">
                        <label htmlFor="id">
                            <div className="form-label">ID<b style={{color:'red'}}>&nbsp;*</b></div>
                            <input 
                            className="form-input"
                            type="text" 
                            id="id" 
                            name="id"
                            value={formData.id}
                            disabled
                            required
                            onChange={ handleInputChange }
                            />
                        </label>
                        </div>
                        <div className="form-box">
                        <label htmlFor="email">
                            <div className="form-label">E-mail<b style={{color:'red'}}>&nbsp;*</b></div>
                            <input 
                            className="form-input"
                            type="text" 
                            id="email" 
                            name="email"
                            value={formData.email}
                            disabled
                            required
                            onChange={ handleInputChange }
                            />
                        </label>
                        </div>
                        <div className="form-box">
                        <label htmlFor="name">
                            <div className="form-label">이름<b style={{color:'red'}}>&nbsp;*</b></div>
                            <input 
                            className="form-input"
                            type="text" 
                            id="name" 
                            name="name" 
                            value={formData.name}
                            placeholder="이름을 입력해주세요" 
                            required 
                            onChange={ handleInputChange }/>
                        </label>
                        </div>
                        <div className="form-box">
                        <label htmlFor="cellphone">
                            <div className="form-label">핸드폰번호</div>
                            <input 
                            className="form-input"
                            type="text" 
                            id="cellphone" 
                            name="cellphone" 
                            value={formData.cellphone}
                            placeholder="핸드폰번호를 입력해주세요" 
                            onChange={ handleInputChange }/>
                        </label>
                        </div>

                        <div className="form-box">
                        <label htmlFor="role">
                            <div className="form-label">권한<b style={{color:'red'}}>&nbsp;*</b></div>
                            <div className="form-check-radio">
                              <Label className="form-check-label">
                                  <Input type="radio" name="role" id="Radios1" value="user" onClick={handleInputChange} defaultChecked/>
                                  일반 사용자
                                  <span className="form-check-sign"></span>
                              </Label>
                            </div>
                            <div className="form-check-radio">
                              <Label className="form-check-label">
                                <Input type="radio" name="role" id="Radios2" value="admin" onClick={handleInputChange} />
                                관리자
                                <span className="form-check-sign"></span>
                              </Label>
                            </div>

                        </label>
                        </div>

                        <div className="form-box">
                          <div className="form-label" style={{width:"150px"}}>비밀번호 초기화</div>
                          <input 
                          type="button" 
                          className="itsBtnGray"
                          style={{width:'140px'}}
                          id="passwordInitialize" 
                          name="passwordInitialize" 
                          value='비밀번호 초기화'
                          onClick={passwordInitialize}/>
                        </div>

                        <div className="form-box">
                          <div className="form-label" style={{width:"150px"}}>회원 탈퇴</div>
                            <a href="/">
                              <Button type="button" onClick={deleteUser} style={{backgroundColor:'transparent',color:'gray',textDecoration:'underline'}}>
                                회원탈퇴
                              </Button>
                            </a>
                        </div>

                        {errorMessage.message && (
                              <div className="errorMessage" style={{ color: 'red', marginBottom:'10px' }}>{errorMessage.message.code}</div>
                            )}

                        <div className="form-button">
                            <div className="board-write-button-area">
                              <input type="button" className="itsBtnGray"  onClick={(e) => {e.preventDefault(navigate(-1))}} value="이전"/>
                              <input type="submit" value="업데이트"/><br/>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
                </div>

            </div>
            </div>
          
        </div>
      </div>
    <Footer />
    </>
  );
}